import axios from 'axios';
import store from '../redux/store/store';

const API_URL = import.meta.env.VITE_API_URL;

const getAuthHeaders = () => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return userToken ? { Authorization: `Bearer ${userToken}` } : {};
};

export const priceRuleService = {
    // Fiyat kurallarını getir
    getPriceRules: async (page = 1, searchTerm = '') => {
        return axios.get(`${API_URL}/PriceRule`, {
            headers: getAuthHeaders(),
            params: { page, title: searchTerm }
        });
    },
    // Yeni fiyat kuralı ekle
    addPriceRule: async (priceRule) => {
        return axios.post(`${API_URL}/PriceRule`, priceRule, {
            headers: getAuthHeaders()
        });
    },
    // Fiyat kuralını sil
    deletePriceRule: async (id) => {
        return axios.delete(`${API_URL}/PriceRule`, {
            headers: getAuthHeaders(),
            params: { id: id }
        });
    },
    // Fiyat kuralını güncelle
    updatePriceRule: async (id, priceRule) => {
        return axios.put(`${API_URL}/PriceRule/${id}`, priceRule, {
            headers: getAuthHeaders()
        });
    },
    // Kategoriye fiyat kuralı ata (toplu)
    assignPriceRuleToCategories: async (priceRuleId, categoryIds) => {
        // categoryIds: [id, id, ...]
        return axios.put(`${API_URL}/Category`, categoryIds.map(id => ({ id, priceRuleId })), {
            headers: getAuthHeaders()
        });
    },
    // Bir kurala bağlı kategorileri getir
    getCategoriesByPriceRule: async (priceRuleId, page = 1, searchTerm = '') => {
        return axios.get(`${API_URL}/Category`, {
            headers: getAuthHeaders(),
            params: { priceRuleId, page, searchTerm }
        });
    },
    // Tekil kategoriden fiyat kuralı kaldır (priceRuleId=null)
    removePriceRuleFromCategory: async (payload) => {
        return axios.put(`${API_URL}/Category`, payload, {
            headers: getAuthHeaders()
        });
    }
}; 